module.exports = __webpack_public_path__ + "img/img-6mobile.5eb1d03d.webp";